<!-- Mobile, header -->
<div class="d-block d-md-none" *ngIf="showHeader">
    <div *ngIf="vm.rowsFiltered.length">
        <mdb-accordion [multiple]="false" aria-multiselectable="true">
            <mdb-accordion-item [collapsed]="true">
                <mdb-accordion-item-head> {{vm.data.title}}</mdb-accordion-item-head>
                <mdb-accordion-item-body>
                    <div *ngIf="vm.select && vm.select.options && vm.select.options.length">
                        <select class="browser-default custom-select select-box"
                            (ngModelChange)="getSelectedValue(vm, $event)" [ngModel]="selectedValue">
                            <option *ngFor="let o of vm.select.options;" [value]="o.value">
                                {{o.label}}
                            </option>
                        </select>
                    </div>
                    <div *ngFor="let r of vm.rowsFiltered; index as i">
                        <mdb-card cascade="true" narrower="true" class="pt-3">
                            <div class="row" *ngIf="keyColumn >= 0">
                                <div class="col-9 col-sm-8">
                                    <div *ngIf="vm.styleTypesFiltered && vm.styleTypesFiltered.length"
                                        [ngClass]="getMobileClass(vm.styleTypesFiltered[i].rowStyle)">
                                        <h4 class="card-header-title">{{r.fields[keyColumn]}}</h4>
                                    </div>
                                    <div *ngIf="!vm.styleTypesFiltered || !vm.styleTypesFiltered.length">
                                        <h4 class="card-header-title">{{r.fields[keyColumn]}}</h4>
                                    </div>
                                </div>
                            </div>
                            <mdb-card-body cascade="true" class="pb-0 px-2">
                                <mdb-card-text>
                                    <div *ngFor="let f of r.fields; index as c">
                                        <div class="row" *ngIf="c != keyColumn">
                                            <div class="col-5 text-right"><b>{{vm.data.columns[c]}}:</b></div>
                                            <div class="col-7">
                                                <strong>
                                                    <div
                                                        [ngClass]="{'warning-cell': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].cellStyle && vm.styleTypesFiltered[i].cellStyle==1 && vm.styleTypesFiltered[i].cellToApplyStyle == c, 'danger-cell': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].cellStyle && vm.styleTypesFiltered[i].cellStyle==2 && vm.styleTypesFiltered[i].cellToApplyStyle == c}">
                                                        <div *ngIf="f && f.includes('|')">
                                                            <div *ngFor="let f2 of f.split('|')">
                                                                <div *ngIf="f2 == '[new-line]'">
                                                                    <br />
                                                                </div>
                                                                <div *ngIf="f2 != '[new-line]'">
                                                                    {{f2}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div *ngIf="f && !f.includes('|')">{{f}}</div>
                                                    </div>
                                                </strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="includeAction && keyColumn >= 0" class="d-flex justify-content-start">
                                        <button mdbBtn color="default" type="button" outline="true" rounded="true"
                                            size="sm" mdbWavesEffect
                                            (click)="action(r.fields[keyColumn], vm.data.title)">{{
                                            r.actionTitle
                                            ||
                                            'validate'}}
                                        </button>
                                    </div>

                                    <!-- row actions -->
                                    <div *ngIf="r.actions && r.actions.length"  class="text-center">
                                        <a *ngFor="let a of r.actions" class="underlined pl-3" href="javascript:null"
                                            (click)="onRowActionClick(vm, r.code, a.code)">
                                            {{a.name}}
                                        </a>
                                    </div>                                    
                                </mdb-card-text>
                            </mdb-card-body>
                        </mdb-card>
                    </div>
                </mdb-accordion-item-body>
            </mdb-accordion-item>
        </mdb-accordion>
    </div>
</div>


<!-- Mobile, no header -->
<div class="d-block d-md-none" *ngIf="!showHeader">
    <div *ngIf="vm.rowsFiltered.length">
        <div class="row">
            <div class="col-md-12">
                <div *ngIf="vm.select && vm.select.options && vm.select.options.length">
                    <select class="browser-default custom-select select-box"
                        (ngModelChange)="getSelectedValue(vm, $event)" [ngModel]="selectedValue">
                        <option *ngFor="let o of vm.select.options;" [value]="o.value">
                            {{o.label}}
                        </option>
                    </select>
                </div>
                <div *ngFor="let r of vm.rowsFiltered; index as i">
                    <mdb-card cascade="true" narrower="true" class="pt-3">
                        <div class="row" *ngIf="keyColumn >= 0">
                            <div class="col-9 col-sm-8">
                                <div *ngIf="vm.styleTypesFiltered && vm.styleTypesFiltered.length"
                                    [ngClass]="getMobileClass(vm.styleTypesFiltered[i].rowStyle)">
                                    <h4 class="card-header-title">{{r.fields[keyColumn]}}</h4>
                                </div>
                                <div *ngIf="!vm.styleTypesFiltered || !vm.styleTypesFiltered.length">
                                    <h4 class="card-header-title">{{r.fields[keyColumn]}}</h4>
                                </div>
                            </div>
                        </div>
                        <mdb-card-body cascade="true" class="pb-0 px-2">
                            <mdb-card-text>
                                <div *ngFor="let f of r.fields; index as c">
                                    <div class="row" *ngIf="c != keyColumn">
                                        <div class="col-5 text-right"><b>{{vm.data.columns[c]}}:</b></div>
                                        <div class="col-7">
                                            <strong>
                                                <div
                                                    [ngClass]="{'warning-cell': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].cellStyle && vm.styleTypesFiltered[i].cellStyle==1 && vm.styleTypesFiltered[i].cellToApplyStyle == c, 'danger-cell': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].cellStyle && vm.styleTypesFiltered[i].cellStyle==2 && vm.styleTypesFiltered[i].cellToApplyStyle == c}">
                                                    <div *ngIf="f && f.includes('|')">
                                                        <div *ngFor="let f2 of f.split('|')">
                                                            <div *ngIf="f2 == '[new-line]'">
                                                                <br />
                                                            </div>
                                                            <div *ngIf="f2 != '[new-line]'">
                                                                {{f2}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div *ngIf="f && !f.includes('|')">{{f}}</div>
                                                </div>
                                            </strong>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="includeAction && keyColumn >= 0" class="d-flex justify-content-start">
                                    <button mdbBtn color="default" type="button" outline="true" rounded="true" size="sm"
                                        mdbWavesEffect (click)="action(r.fields[keyColumn], vm.data.title)">{{
                                        r.actionTitle
                                        ||
                                        'validate'}}
                                    </button>
                                </div>

                                <!-- row actions -->
                                <div *ngIf="r.actions  && r.actions.length" class="text-center">
                                    <a *ngFor="let a of r.actions" class="underlined pl-3" href="javascript:null"
                                        (click)="onRowActionClick(vm, r.code, a.code)">
                                        {{a.name}}
                                    </a>
                                </div>                                    

                            </mdb-card-text>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </div>
        </div>

    </div>
</div>

<!-- Desktop, with header  -->
<div class="d-none d-md-block" *ngIf="showHeader">
    <mdb-card narrower="true" cascade="true">
        <app-card-header *ngIf="showTitle" [title]="vm.data.title" [subTitle]="subTitle" [headingSize]="3"></app-card-header>
        <mdb-card-body cascade="true">
            <div class="row">
                <div class="col-md-12 text-center">
                    <div *ngIf="vm.select && vm.select.options && vm.select.options.length">
                        <select class="browser-default select-box" (ngModelChange)="getSelectedValue(vm, $event)"
                            [ngModel]="selectedValue">
                            <option *ngFor="let o of vm.select.options;" [value]="o.value">
                                {{o.label}}
                            </option>
                        </select>
                        <hr />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <span *ngIf="!vm.rowsFiltered.length">No data found at the moment!</span>

                    <table *ngIf="vm.rowsFiltered.length" mdbTable mdbTableScroll scrollY="true" maxHeight="{{tableMaxHeight}}" striped="true" small="true"
                        style="table-layout: fixed">
                        <thead>
                            <tr>
                                <th scope="col" *ngFor="let c of vm.data.columns" style="font-size: small;">{{c}}</th>
                                <th *ngIf="includeAction" style="font-size: small;"></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr mdbTableCol *ngFor="let r of vm.rowsFiltered; index as i"
                                [ngClass]="{'warning-row': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].rowStyle && vm.styleTypesFiltered[i].rowStyle==1, 'danger-row': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].rowStyle && vm.styleTypesFiltered[i].rowStyle==2}">
                                <td *ngFor="let f of r.fields; index as fi" style="font-size: small;">
                                    <ng-container *ngIf="vm.styleTypesFiltered && vm.styleTypesFiltered.length">
                                        <div *ngIf="fi != r.fields.length-1 || vm.data.columns[r.fields.length-1] !== 'Info'"
                                            [ngClass]="{'warning-cell': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].cellStyle && vm.styleTypesFiltered[i].cellStyle==1 && vm.styleTypesFiltered[i].cellToApplyStyle == fi, 'danger-cell': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].cellStyle && vm.styleTypesFiltered[i].cellStyle==2 && vm.styleTypesFiltered[i].cellToApplyStyle == fi}">
                                            <div *ngIf="f && f.includes('|')">
                                                <div *ngFor="let f2 of f.split('|')">
                                                    <div *ngIf="f2 == '[new-line]'">
                                                        <br />
                                                    </div>
                                                    <div *ngIf="f2 != '[new-line]'">
                                                        {{f2}}
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="f && !f.includes('|')">{{f}}</div>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="!vm.styleTypesFiltered || !vm.styleTypesFiltered.length">
                                        <div *ngIf="f && f.includes('|')">
                                            <div *ngFor="let f2 of f.split('|')">
                                                <div *ngIf="f2 == '[new-line]'">
                                                    <br />
                                                </div>
                                                <div *ngIf="f2 != '[new-line]'">
                                                    {{f2}}
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="f && !f.includes('|')">{{f}}</div>
                                    </ng-container>
                                    <span
                                        *ngIf="fi===r.fields.length-1 && f && f.length && vm.data.columns[r.fields.length-1]==='Info'">
                                        <a style="color: #0099CC;" href="javascript:null" role="button"
                                            placement="bottom" [title]="f">
                                            <i class="fa fa-info-circle fa-lg"></i>
                                        </a>
                                    </span>
                                </td>
                                <td *ngIf="includeAction && keyColumn >= 0" style="width:150px; font-size: small;">
                                    <div class="d-flex justify-content-start">
                                        <button mdbBtn color="default" type="button" outline="true" rounded="true"
                                            size="sm" mdbWavesEffect
                                            (click)="action(r.fields[keyColumn], vm.data.title)">{{
                                            r.actionTitle ||
                                            'validate'}}
                                        </button>
                                    </div>
                                </td>

                                <td *ngIf="vm.actions && vm.actions.length && vm.actions[i]" style="width:30px;">
                                    <div class="dropdown" mdbDropdown style="margin-top: -0.8em;">
                                        <button mdbDropdownToggle mdbBtn color="primary" size="sm"
                                            class="dropdown-toggle waves-light" type="button" mdbWavesEffect>
                                            Actions
                                        </button>

                                        <div class="dropdown-menu dropdown-primary">
                                            <button *ngFor="let a of vm.actions[i].actions" class="dropdown-item"
                                                (click)="onActionClick(a, vm.actions[i].entityCode)">{{a.name}}</button>
                                        </div>
                                    </div>
                                </td>

                                <!-- row specific actions -->
                                <td *ngIf="r.actions  && r.actions.length">
                                    <div *ngFor="let a of r.actions">
                                        <a class="underlined pl-3" href="javascript:null"
                                            (click)="onRowActionClick(vm, r.code, a.code)">
                                            {{a.name}}
                                        </a>
                                    </div>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </mdb-card-body>
    </mdb-card>
</div>

<!-- desktop, no header -->
<div class="d-none d-md-block" *ngIf="!showHeader">
    <div class="row">
        <div class="col-md-12 text-center">
            <div *ngIf="vm.select && vm.select.options && vm.select.options.length">
                <select class="browser-default select-box" (ngModelChange)="getSelectedValue(vm, $event)"
                    [ngModel]="selectedValue">
                    <option *ngFor="let o of vm.select.options;" [value]="o.value">
                        {{o.label}}
                    </option>
                </select>
                <hr />
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <span *ngIf="!vm.rowsFiltered.length">No data found at the moment!</span>

            <table *ngIf="vm.rowsFiltered.length" mdbTable striped="true" small="true" style="table-layout: fixed;">
                <thead>
                    <tr>
                        <th scope="col" *ngFor="let c of vm.data.columns" style="font-size: small;"><strong>{{c}}</strong></th>
                        <th *ngIf="includeAction || vm.showActionColumn" style="font-size: small;"><strong>Actions</strong></th>
                    </tr>
                </thead>

                <tbody>
                    <tr mdbTableCol *ngFor="let r of vm.rowsFiltered; index as i"
                        [ngClass]="{'warning-row': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].rowStyle && vm.styleTypesFiltered[i].rowStyle==1, 'danger-row': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].rowStyle && vm.styleTypesFiltered[i].rowStyle==2}">
                        <td *ngFor="let f of r.fields; index as fi" style="font-size: small;">
                            <ng-container *ngIf="vm.styleTypesFiltered && vm.styleTypesFiltered.length">
                                <div *ngIf="fi != r.fields.length-1 || vm.data.columns[r.fields.length-1] !== 'Info'"
                                    [ngClass]="{'warning-cell': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].cellStyle && vm.styleTypesFiltered[i].cellStyle==1 && vm.styleTypesFiltered[i].cellToApplyStyle == fi, 'danger-cell': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].cellStyle && vm.styleTypesFiltered[i].cellStyle==2 && vm.styleTypesFiltered[i].cellToApplyStyle == fi}">
                                    <div *ngIf="f && f.includes('|')">
                                        <div *ngFor="let f2 of f.split('|')">
                                            <div *ngIf="f2 == '[new-line]'">
                                                <br />
                                            </div>
                                            <div *ngIf="f2 != '[new-line]'">
                                                {{f2}}
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="f && !f.includes('|')">{{f}}</div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="!vm.styleTypesFiltered || !vm.styleTypesFiltered.length">
                                <div *ngIf="f && f.includes('|')">
                                    <div *ngFor="let f2 of f.split('|')">
                                        <div *ngIf="f2 == '[new-line]'">
                                            <br />
                                        </div>
                                        <div *ngIf="f2 != '[new-line]'">
                                            {{f2}}
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="f && !f.includes('|')">{{f}}</div>
                            </ng-container>
                            <span
                                *ngIf="fi===r.fields.length-1 && f && f.length && vm.data.columns[r.fields.length-1]==='Info'">
                                <a style="color: #0099CC;" href="javascript:null" role="button" placement="bottom"
                                    [title]="f">
                                    <i class="fa fa-info-circle fa-lg"></i>
                                </a>
                            </span>
                        </td>
                        <td *ngIf="includeAction && keyColumn >= 0" style="width:150px; font-size: small;">
                            <div class="d-flex justify-content-start">
                                <button mdbBtn color="default" type="button" outline="true" rounded="true" size="sm"
                                    mdbWavesEffect (click)="action(r.fields[keyColumn], vm.data.title)">{{
                                    r.actionTitle ||
                                    'validate'}}
                                </button>
                            </div>
                        </td>

                        <!-- row specific actions -->
                        <td *ngIf="r.actions  && r.actions.length">
                            <div *ngFor="let a of r.actions">
                                <a class="underlined pl-3" href="javascript:null"
                                    (click)="onRowActionClick(vm, r.code, a.code)">
                                    {{a.name}}
                                </a>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</div>